<template>
  <div>
    <v-list>
      <v-list-item :to="{ name: '' }">
        <v-list-item-title>Таблица прогресса выполнения заданий</v-list-item-title>
      </v-list-item>
    </v-list>
    <router-view name="activist_metrics"></router-view>
  </div>
</template>

<script>
import { getTaskMetricsCountsResponse } from '@/api/activist/metrics'

export default {
  name: 'ActivistMetricsIndex',
}
</script>
